import { createSelector } from '@ngrx/store';
import { AuthorsState } from '../state/authors.state';
import { AppState } from '../state/state';
import { ODataGetListFormModel } from '@evorait/pace-forms';

export const getAuthorsState = (state: AppState): AuthorsState => state.authorsState;

export const getTestFormsList = createSelector(
    getAuthorsState,
    (state: AuthorsState): ODataGetListFormModel[] => state.formsList,
);
